// extracted by mini-css-extract-plugin
export default {"container":"g__container--MkKy5"};